







































import { defineComponent, ref, computed } from '@vue/composition-api'
import { useQuery, useResult } from '@vue/apollo-composable'
import emailTemplatesQuery from '@/lib/graphql/emailTemplates.query.gql'

export default defineComponent({
  setup(_, { root }) {
    const locales = ['en', 'zh']
    const locale = ref(locales[0])

    const params = computed(() => ({
      where: {
        locale: { _eq: locale.value }
      }
    }))

    const { result, loading, onError } = useQuery(emailTemplatesQuery, params)
    const data = useResult(result)
    onError(error => {
      console.error(error)
      root.$notification.error({
        message: 'Error',
        description: 'An error occurred'
      })
    })

    return {
      locales,
      locale,

      loading,
      data
    }
  }
})
